import { Component, Input, OnInit } from '@angular/core';
import { Offer } from '../../../../../core/models/offer/offer.model';
import {isCarOne} from '../../../../../core/utils/utils';

@Component({
  selector: 'app-offer-fixed-price',
  templateUrl: './offer-fixed-price.component.html',
  styleUrls: ['./offer-fixed-price.component.scss']
})
export class OfferFixedPriceComponent implements OnInit {
  @Input() offer: Offer;
  @Input() showInstalment: boolean = true;
  @Input() selectedPremium: string;

  mainTailsSeparator: string = isCarOne() ? '.' : ',';

  constructor() { }

  ngOnInit() {
  }

}
